<template>
    <div>
        <top-navbar :padding="topPadding" :breadcrumb="breadcrumb"></top-navbar>

        <div class="container-fluid mt--6">

            <div class="pt-5" v-show="hasNotice">
                <app-status :remote-version="appVersion" @show="appStatus = true"></app-status>
                <offline-status @show="offlineStatus = true" ref="offlineStatus" :autoload="false"></offline-status>
            </div>

            <div class="row">
                <div class="col-md-12">
                    <sessions @refresh-offline-status="$refs.offlineStatus.refresh()"></sessions>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Sessions from './sessions/Sessions';
    import OfflineStatus from './offline/HomeStatus';
    import AppStatus from './offline/AppStatus';

    export default {

        components: {
            Sessions, OfflineStatus, AppStatus
        },

        data() {
            return {
                appStatus: false,
                offlineStatus: false,
                registration: null,
                learner: null,
            }
        },

        computed: {

            breadcrumb() {
                if (this.registration) {
                    return [
                        {
                            name: this.$t('common.sessions'),
                            route: '/socrates/ui/dashboard/sessions'
                        },
                        {
                            name: this.registration.cohort.name + ' / ' + this.registration.degree.name,
                            route: '/socrates/ui/dashboard/sessions/registrations/' + this.registration.id
                        },
                        {
                            name: this.learner.name
                        },
                    ]
                } else {
                    return [
                        {
                            name: this.$t('common.sessions'),
                        },
                    ]
                }
            },

            appVersion() {
                return this.$auth['config'].app_version
            },

            hasNotice() {
                return this.appStatus || this.offlineStatus
            },

            topPadding() {
                return this.hasNotice ? 4 : 6
            }
        },

        beforeRouteEnter(to, from, next) {
            Vue.prototype.$loader.show()
            axios.get('/socrates/api/front/dashboard/page/sessions/registrations/' + to.params.registrationId + '/learners/' + to.params.learnerId)
            .then(resp => {
                next(vm => {
                    vm.registration = resp.data.data
                    vm.learner = resp.data.included.learner
                    vm.$permissions.setRights(resp.data.included.rights)
                    vm.$loader.hide()
                })
            })
            .catch(err => {
                if (err.response.status == 403) {
                    next({ name: 'unauthorized' });
                }
            });
        },
    }
</script>
